import type { CompetencyItemStatus } from "../types";

import { resolveCompetencies, useCompetencyCreation } from "./useCompetencyCreation";

import { useAskPerformYardStore } from "../AskPerformYardStore";

export const useCompetencyFrameworkView = () => {
	const framework = useAskPerformYardStore((state) => state.competencyFramework);
	const { saveFramework, createOne, removeOne, isSaving } = useCompetencyCreation();

	const suggestions = framework?.suggestions ?? [];
	const editedFields = framework?.editedFields ?? {};
	const itemStatuses = framework?.itemStatuses ?? {};

	const itemStatus = (id: string): CompetencyItemStatus => itemStatuses[id] ?? "pending";
	const visible = suggestions.filter((suggestion) => itemStatus(suggestion.id) !== "removed");
	const pending = visible.filter((suggestion) => itemStatus(suggestion.id) === "pending");
	const someCreated = visible.some((suggestion) => itemStatus(suggestion.id) === "created");
	const anyCreating = visible.some((suggestion) => itemStatus(suggestion.id) === "creating");
	const isDone = framework?.status === "saved" || (someCreated && pending.length === 0 && !anyCreating);

	const bulkSave = () =>
		saveFramework(
			resolveCompetencies(pending, editedFields),
			pending.map((suggestion) => suggestion.id)
		);

	return {
		framework,
		editedFields,
		itemStatus,
		visible,
		pending,
		someCreated,
		isDone,
		createOne,
		removeOne,
		isSaving,
		bulkSave,
	};
};
